import { HashTable } from "../HashTable";

function WebSocketClient(socketAck) {
  this.ip; //ip
  this.port; //端口
  this.operator; //操作员

  this.connected = false; //当前的链接状态

  var socket; //websocket实例

  this.socketAck = socketAck;

  this.heat = undefined;

  var isLogOut = false;

  var serial_no = 0;
  var SrvVer = 1;
  var serialNumberList = new HashTable();

  this.init = (ip, port, operator) => {
    this.ip = ip;
    this.port = port;
    this.operator = operator;
    this.Connect();
  };

  //连接socket服务
  this.Connect = () => {
    var protocolStr = document.location.protocol;
    var host = "ws://" + this.ip;
    if (protocolStr == "http:") {
      host = "ws://" + this.ip;
    } else if (protocolStr == "https:") {
      host = "wss://" + this.ip;
    }

    if (WebSocket) {
      socket = new WebSocket(host);
      socket.onopen = (msg) => {
        this.connected = true;
        isLogOut = false;
        this.SocketSendData("Init", {
          _strHost: this.ip,
          _iPort: this.port,
          _iOperID: this.operator,
        });
        this.SocketSendData("Connect", {});
      };
      socket.onmessage = (msg) => {
        try {
          var obj = JSON.parse(msg.data);
          // console.log(obj);
          if (obj.Method) {
            if (obj.Method == "ConnectAck") {
              if (this.socketAck) {
                this.socketAck.ConnectAck();
                //设置定时器
                if (this.heat) clearInterval(this.heat);
                this.heat = setInterval(() => {
                  this.SocketSendData("HeartBeat", {});
                }, 10 * 1000);
              }
            } else {
              if (
                obj.Paras &&
                obj.Paras["v_strMsgID"] &&
                serialNumberList.contains(obj.Paras["v_strMsgID"])
              ) {
                //把原来的对象传递过去
                // console.log("websocket");
                // console.log(serialNumberList.items(obj.Paras["v_strMsgID"]));
                this.socketAck.WebSocketAck(
                  obj,
                  serialNumberList.items(obj.Paras["v_strMsgID"])
                );
                // if (",DeviceLogUploadSuccessAck,SetAutoDriveSystemParasAck".indexOf(obj.Method) < 0)
                // serialNumberList.remove(obj.Paras["v_strMsgID"]);
              }
            }
          }
        } catch (error) {}
      };
      socket.onclose = (msg) => {
        //断开需要重连
        if (!isLogOut) this.socketAck.DisConnectAck();
        this.connected = false;
        if (this.heat) clearInterval(this.heat);
        // console.log("websocket 关闭" + msg);
      };
    }
  };

  this.close = () => {
    isLogOut = true;
    socket.close();
  };

  this.DisConnect = function () {
    return this.SocketSendData("DisConnect", {});
  };

  //获取车辆最后位置  _uiTotalRecord 数量  _szParam 车辆ID数组 [100844]
  this.GetVelLastGPSExReq = function (_uiTotalRecord, _szParam) {
    return this.SocketSendData("GetVelLastGPSExReq", {
      _uiTotalRecord: parseInt(_uiTotalRecord),
      _szParam: _szParam,
    });
  };

  this.takePhotoReq = function (
    strPhone,
    uiChannelID,
    uiCommand,
    uiInterval,
    uiSaveMode,
    uiResolution,
    uiQuality,
    uiBrightness,
    uiContrast,
    uiSaturation,
    uiColor
  ) {
    return this.SocketSendData("TakePhotoReq", {
      _strPhone: strPhone,
      _uiChannelID: parseInt(uiChannelID),
      _uiCommand: parseInt(uiCommand),
      _uiInterval: parseInt(uiInterval),
      _uiSaveMode: parseInt(uiSaveMode),
      _uiResolution: parseInt(uiResolution),
      _uiQuality: parseInt(uiQuality),
      _uiBrightness: parseInt(uiBrightness),
      _uiContrast: parseInt(uiContrast),
      _uiSaturation: parseInt(uiSaturation),
      _uiColor: parseInt(uiColor),
    });
  };

  this.QueryResourceListReq = function (
    _strPhone,
    _uiChannel,
    _strBeginTime,
    _strEndTime,
    _uiAlarmFlag,
    _uiResourceType,
    _uiCodedType,
    _uiMemoryType
  ) {
    return this.SocketSendData("QueryResourceList", {
      _strPhone: _strPhone,
      _uiChannel: parseInt(_uiChannel),
      _strBeginTime: _strBeginTime,
      _strEndTime: _strEndTime,
      _uiAlarmFlag: parseInt(_uiAlarmFlag),
      _uiResourceType: parseInt(_uiResourceType),
      _uiCodedType: parseInt(_uiCodedType),
      _uiMemoryType: parseInt(_uiMemoryType),
    });
  };

  this.RemoteVideoReplayReq = function (
    _strPhone,
    _strIP,
    _uiTCPPort,
    _uiUDPPort,
    _uiChannel,
    _uiDataType,
    _uiCodedType,
    _uiMemoryType,
    _uiReplayType,
    _uiReplaySpeed,
    _strBeginTime,
    _strEndTime
  ) {
    return this.SocketSendData("RemoteVideoReplayReq", {
      _strPhone: _strPhone,
      _strIP: _strIP,
      _uiTCPPort: parseInt(_uiTCPPort),
      _uiUDPPort: parseInt(_uiUDPPort),
      _uiChannel: parseInt(_uiChannel),
      _uiDataType: parseInt(_uiDataType),
      _uiCodedType: parseInt(_uiCodedType),
      _uiMemoryType: parseInt(_uiMemoryType),
      _uiReplayType: parseInt(_uiReplayType),
      _uiReplaySpeed: parseInt(_uiReplaySpeed),
      _strBeginTime: _strBeginTime,
      _strEndTime: _strEndTime,
    });
  };

  this.RemoteVideoReplayControl = function (
    _strPhone,
    _uiChannel,
    _uiReplayControl,
    _uiReplaySpeed,
    _strTime
  ) {
    return this.SocketSendData("RemoteVideoReplayControl", {
      _strPhone: _strPhone,
      _uiChannel: parseInt(_uiChannel),
      _uiReplayControl: parseInt(_uiReplayControl),
      _uiReplaySpeed: parseInt(_uiReplaySpeed),
      _strTime: _strTime,
    });
  };

  this.MultiMediaDeviceRealTimeTransferControl = function (
    _strPhone,
    _uiChannel,
    _uiControl,
    _uiCloseType,
    _uiCodedType
  ) {
    return this.SocketSendData("MultiMediaDeviceRealTimeTransferControl", {
      _strPhone: _strPhone,
      _uiChannel: parseInt(_uiChannel),
      _uiControl: parseInt(_uiControl),
      _uiCloseType: parseInt(_uiCloseType),
      _uiCodedType: parseInt(_uiCodedType),
    });
  };

  this.RealTimeMultiMediaDeviceTransferReq = function (
    _strPhone,
    _strIP,
    _uiTCPPort,
    _uiUDPPort,
    _uiChannel,
    _uiDataType,
    _uiCodedType
  ) {
    return this.SocketSendData("RealTimeMultiMediaDeviceTransferReq", {
      _strPhone: _strPhone,
      _strIP: _strIP,
      _uiTCPPort: parseInt(_uiTCPPort),
      _uiUDPPort: parseInt(_uiUDPPort),
      _uiChannel: parseInt(_uiChannel),
      _uiDataType: parseInt(_uiDataType),
      _uiCodedType: parseInt(_uiCodedType),
    });
  };

  this.QueryMultiMediaDeviceParamReq = function (_strPhone) {
    return this.SocketSendData("QueryMultiMediaDeviceParamReq", {
      _strPhone: _strPhone,
    });
  };

  //往行驶记录仪发送消息
  this.SendInfomation = (phone, flag, infomation) => {
    return this.SocketSendData("SendInfomation", {
      _strPhone: phone,
      _uiFlag: flag,
      _strInfomation: infomation,
    });
  };

  this.VelOnlineStateReq = function (_uiTotalRecord,_szParam) {
    return this.SocketSendData("VelOnlineStateReq", {
      _uiTotalRecord: _uiTotalRecord,
      _szParam: _szParam,
    });
  };

  this.SocketSendData = (method, para) => {
    var paraHere = JSON.parse(JSON.stringify(para));
    if (this.connected) {
      //发送数据
      if (method != "HeartBeat") {
        ++serial_no;
        var temp_ = serial_no;
        //如果是北斗的协议，流水号需要处理
        if (method.indexOf("VTDR_BD_") > -1) {
          temp_ = temp_ | 0x8000;
          temp_ = temp_ & 0xffff;
        }

        paraHere["_strMsgID"] = temp_; //增加流水号，保存到数组
        paraHere["Timestamp"] = Date.parse(new Date()) / 1000; //增加时间戳(秒级），保存到数组
        //这个数据，在数据返回的时候应该会用到,用来判断超时

        serialNumberList.add(temp_, {
          _strMsgID: temp_,
          Timestamp: paraHere["Timestamp"],
          Method: method,
          params: JSON.stringify(para), //保持之前的参数
        });
      }
      var msg = {
        Method: method,
        OperatorID: this.operator,
        SrvVer: SrvVer,
        Paras: paraHere,
      };
      socket.send(JSON.stringify(msg));

      return paraHere["_strMsgID"];
    } else {
      return -1;
    }
  };
}

export { WebSocketClient };
